import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { actions } from "../../store/reducers/authentication";
import { getRedirectPath } from "../../constants/user";
import useQuery from "../../helpers/useQuery";
import Loading from "../Loading";
import { message } from "antd";
import Redirect from "../Redirect";
import { useParams } from "react-router-dom";

const mstp = ({ authentication }) => ({ authentication });
const Verify = ({
  authentication: { verifying, verificationFailed, errors, verified, user },
  verify,
}) => {
  const { app } = useParams();
  const params = useQuery();
  const code = params.get('code');
  useEffect(() => {
    verify(code)
  }, [code, verify]);

  const { t } = useTranslation();
  const [redirect, setRedirect] = useState(false);

  if (verified) setTimeout(() => setRedirect(true), 500);

  useEffect(() => {
    if (errors && errors.link) {
      const parts = errors.link[0].split(". ");
      if (Array.isArray(parts) && parts[0]) {
        message.error(t(parts[0]))
      }
    }
  }, [errors]);

  return verifying || verificationFailed ? (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",

      }}
      className="flex-row justify-center"
    >
      <Loading />
    </div>
  ) : !redirect ? (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
      }}
      className="flex-row justify-center"
    >
      <Loading />
    </div>
  ) : (
    <Redirect to={getRedirectPath(user, '', app)} />
  );
};

export default connect(mstp, actions)(Verify);
